// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { dreyerxTestnet as _dreyerxTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the dreyerxTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 23452
 * Chain Name: DreyerX Testnet
 * Default Block Explorer: https://testnet-scan.dreyerx.com
 * Default RPC URL: http://testnet-rpc.dreyerx.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { dreyerxTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: dreyerxTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const dreyerxTestnet = createCommon({
	..._dreyerxTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
